<div class="container">
   <div class="columns">
      <div class="column">
         <ng-container *ngIf="(cartItems$ | async) as cartItems">
            <table class="table is-striped is-narrow is-hoverable">
               <thead *ngIf="cartItems.length > 0">
                  <tr>
                     <th></th>
                     <th>Kod</th>
                     <th>İsim</th>

                     <th>Adet</th>
                     <th>Fiyat</th>
                     <th>Toplam</th>
                     <th></th>
                     <!-- <th>Görsel</th> -->
                  </tr>
               </thead>

               <tfoot *ngIf="cartProperties$ |async as cartProperties">
                  <tr class="has-text-right">
                     <th colspan="5">Ürün toplamı</th>

                     <th>{{ cartProperties.cartTotal| number: '1.2-2' }} TL</th>
                     <th></th>
                  </tr>
                  <tr class="has-text-right" *ngIf="cartProperties.cartTax18 > 0">
                     <th colspan="5">KDV%18</th>

                     <th>{{ cartProperties.cartTax18 | number: '1.2-2' }} TL</th>
                  </tr>
                  <tr class="has-text-right" *ngIf="cartProperties.cartTax8 > 0">
                     <th colspan="5">KDV%8</th>

                     <th>{{ cartProperties.cartTax8 | number: '1.2-2' }} TL</th>
                  </tr>
                  <tr class="has-text-right">
                     <th colspan="5">Genel toplam</th>

                     <th>{{ cartProperties.cartGrandTotal | number: '1.2-2' }} TL</th>
                  </tr>
               </tfoot>

               <tbody>
                  <tr
                     *ngFor="let item of cartItems; let i = index"
                     [ngClass]="{ 'has-text-grey-light': item.qty === 0, 'has-text-danger': item.qty < 0 }"
                  >
                     <td>{{ i + 1 }}</td>
                     <td>{{ item.code }}</td>
                     <td>{{ item.name | slice: 0:20 }}</td>
                     <td class="has-text-right">{{ item.qty }}</td>
                     <td class="has-text-right">{{ item.sprice | number: '1.2-2' }}</td>
                     <td class="has-text-right">{{ item.tprice| number: '1.2-2' }} {{ item.scurr }}</td>
                     <td>
                        <p>
                           <span class="icon  has-text-info" title="1 adet çıkart" (click)="onRemoveOne(item)">
                              <i class="fas fa-minus"></i>
                           </span>

                           <span class="icon  has-text-success" title="1 adet ekle" (click)="onAddOne(item)">
                              <i class="fas fa-plus"></i>
                           </span>
                           <span class="icon has-text-warning" title="satırı sil" (click)="onRemoveRow(item)">
                              <i class="fas fa-trash"></i>
                           </span>
                           <span class="icon has-text-danger" title="iade al" (click)="onReturnRow(item)">
                              <i class="fas fa-exchange-alt"></i>
                           </span>
                        </p>
                     </td>
                     <!-- <td>
                        <figure class="image is-64x64">
                           <img [src]="item.imgUrl" />
                        </figure>
                     </td> -->
                  </tr>
               </tbody>
            </table>
         </ng-container>
      </div>
   </div>
</div>
